export const OPTIMUS = {
  APIURL: 'https://optimus.kpfui.dev/api/v2/',
  PROJECTBUCKET: 'kpfui-scout-project-bucket'
}
